import PaymentTransactionItemsResult from "../models/paymentTransactionItemsResult"
import {AppContext} from "@lightspeed-invoicing/core-client/frontend"
import {PaymentTransactionSearchPayload} from "../../../payment/PaymentTransactionSearchPayload"
import QueryHelper from "../../../../common/QueryHelper"

class Service {
    static async findPaymentTransactionsByPaymentId(
        payload: PaymentTransactionSearchPayload): Promise<PaymentTransactionItemsResult> {
        const queryParameters = QueryHelper.getQueryParametersStringFromObject(payload, ["productId"])
        const res = await AppContext.getApiClient().get(`/listing/payments/${payload.paymentId}/transactions${queryParameters}`)

        if (res.error) {
            throw new Error(res.error.message)
        }

        return new PaymentTransactionItemsResult(res)
    }
}

export {
    Service
}



// WEBPACK FOOTER //
// ./src/state/listing/payment-transactions/service/service.ts